const state = {
  defalutAvtive: '/page11',
}

const mutations = {
  commonMutations: (state, payload) => {
    state = {...state,...payload}
  },
}

const actions = {
  handleDouble ({ state, commit, payload }) {
      commit('commonMutations',{defalutAvtive:'index'})
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
  